import router from "./router";
import store from "./store";
import portalRoutes from "./router/portal"; // routes of portal site
// import { Message } from "iways-ui";
import { getToken } from "@/utils/auth"; // get token from cookie
import { PermissionFilterBl } from "@/utils/filters"; // get token from cookie
import { getMircoApps } from "@/core/apps";
import { constantRoutes } from "@/router";

// 用于有token的用户 但访问没有权限页面的白名单过滤使用
const whiteList2 = constantRoutes
  .map(item => item.path)
  .filter(item => !["/model-fastview"].includes(item)); // 车型速览是需要单独配置权限所以进行过滤

const homePath = "/portal";

// no redirect whitelist
const whiteList = [
  "/auth-redirect",
  "/autoLogin",
  "/protocol",
  homePath,
  ...portalRoutes.map(item => item.path)
];

/**
 * 验证用户是否进行越权进行访问页面
 **/
const verifyUltraViresFn = (data, to) => {
  if (
    [...whiteList, ...whiteList2].indexOf(to.path) === -1 &&
    !PermissionFilterBl(to.fullPath)
  ) {
    // 进行限制没有权限的页面访问跳转至首页
    const pathArr = to.path.split("/");
    let findObj = null;
    if (pathArr.length > 1) {
      const str = `/${pathArr[1]}`;
      if (["/report"].includes(str)) {
        //  VIP报告 页面处理
        const { product } = to.query;
        const findVal2 = data.find(item => item.path === to.fullPath); // 处理新能源报告
        if (findVal2) return;
        const findVal = data.find(item => item.path === product);
        if (findVal) {
          findObj = findVal.children.find(e => ["VIP报告"].includes(e.title));
        }
      } else {
        // special 为true 表示有部分页面需要显示
        findObj = data.find(
          item =>
            (item.path === str || item.path.indexOf(str) !== -1) &&
            !item.special
        );
      }
      if (!findObj) {
        window.location.href = "/";
      }
    }
  }
};

router.beforeEach(async (to, from, next) => {
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === homePath) {
      // if is logged in, redirect to the home page
      // next({ path: "/" });
      next();
    } else {
      // determine whether the user has obtained his permission roles through getUserInfo
      const hasUser = store.getters.userInfo.userId;
      if (hasUser) {
        next();
        // determine whether the user as obtained his mirco apps through getMircoApps
        const microAppRoutes = store.getters.microAppRoutes;

        if (!microAppRoutes || !microAppRoutes.length) {
          const data = await getMircoApps();
          verifyUltraViresFn(data, to);
        } else {
          verifyUltraViresFn(microAppRoutes, to);
        }
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          await store.dispatch("user/getUserInfo");

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to home page to re-home
          await store.dispatch("user/resetToken");
          // Message.error(error || "Has Error");
          next(`${homePath}?redirect=${to.path}`);
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free home whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the home page.
      next(`${homePath}?redirect=${to.path}`);
    }
  }
});

router.afterEach(() => {
  // finish progress bar
});
